<template>
  <div>
    <b-table
      :items="records"
      :fields="fields"
      :busy="isBusy"
      class="table-person-selected-ipt"
      show-empty
    >
      <template #empty>
        <div class="text-center my-2">
          <h2>Sin datos para mostrar</h2>
        </div>
      </template>
      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <overlay-button></overlay-button>
        </div>
      </template>
      <template #cell(name)="row">
        {{ row.item.name }}<br />
        <b>c.c. {{ row.item.cc }}</b>
      </template>
      <template #cell(action)="row">
        <div v-if="row.item.made_at" class="d-flex align-items-center">
          <span>{{ row.item.made_at }}</span>
          <button
            class="button-table-employee"
            @click.prevent="findItem(row.item)"
          >
            <img
              class="centerImg1 resaltar"
              :src="require('@/assets/images/icons/eye-line.svg')"
            />
          </button>
        </div>
        <div v-else>
          <button
            class="button-primary w-100"
            @click.prevent="formIPT(row.item)"
          >
            <span>Diligenciar IPT </span>
          </button>
        </div>
      </template>
    </b-table>
    <div class="col-12 cont-pagination my-5 d-flex justify-content-center">
      <Pagination
        v-if="!isBusy"
        :data="tablePerson"
        :limit="15"
        @pagination-change-page="loadRowsPag"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import { getEmployeesIpt } from "@/services/health-tracker/ges/service";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import Pagination from "laravel-vue-pagination";
import { mapState } from "vuex";
export default {
  components: {
    OverlayButton,
    Pagination,
  },
  data() {
    return {
      fields: [
        {
          key: "charge",
          label: "Cargo",
        },
        {
          key: "name",
          label: "Nombre / C.C",
        },
        {
          key: "area",
          label: "Área",
        },
        {
          key: "health_condition",
          label: "Condición de salud",
        },
        {
          key: "categorization",
          label: "Categorización",
        },
        {
          key: "action",
          label: "Registro de IPT",
        },
      ],
      id: this.$route.params.id,
      type: this.$route.params.type,
      category: this.$route.params.category,
      isBusy: false,
      tablePerson: {},
      records: [],
      page: 1,
    };
  },
  computed: {
    ...mapState("modSVE", ["ges"]),
  },
  methods: {
    formIPT(item) {
      const me = this;
      me.$router.push({
        name: "formIPT",
        params: {
          id: item.id,
          employee_id: item.employee_id,
          ges_id: item.ges_id,
          category: me.category,
          type: me.type,
        },
      });
    },
    findItem(item) {
      const me = this;
      me.$router.push({
        name: "detailFormIPT",
        params: {
          id: item.id,
          employee_id: item.employee_id,
          ges_id: item.ges_id,
          is_detail: true,
        },
      });
    },
    async getEmployeesIpt() {
      const me = this;
      const params = {
        page: me.page,
      };
      try {
        me.isBusy = true;
        me.records = [];
        me.tablePerson = [];
        const { data } = await getEmployeesIpt(me.id, params);
        me.tablePerson = data;
        // me.tablePerson = {
        //   links: data.links,
        //   data: data.data,
        //   meta: {
        //     current_page: data.current_page,
        //     from: data.from,
        //     last_page: data.last_page,
        //     path: data.path,
        //     per_page: data.per_page,
        //     to: data.to,
        //     total: data.total,
        //   }
        // };
        data?.data?.forEach((x) => {
          me.records.push({
            charge: x?.employee?.position?.name,
            name: x?.employee?.name,
            cc: x?.employee?.cc,
            area: x?.employee?.core_area?.name,
            health_condition: "N/A",
            categorization: x?.categorization ? x?.categorization : "N/A",
            made_at: x?.made_at,
            employee_id: x?.core_employee_id,
            id: x?.id,
            ges_id: x?.ges_id,
            _rowVariant: x?.is_active ? "warning" : ""
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        me.isBusy = false;
      }
    },
    loadRowsPag(page) {
      const me = this;
      me.page = page;
      me.getEmployeesIpt();
    },
  },
  mounted() {
    const me = this;
    me.getEmployeesIpt();
  },
};
</script>

<style lang="scss" scoped>
.table-person-selected-ipt {
  box-shadow: 0 0 4px 2px transparent !important;
  border-radius: 0 !important;
}

.table-person-selected-ipt .table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #e3e4fc !important;
  border: none !important;
}
.button-table-employee {
  border: none !important;
  background-color: transparent !important;
}
</style>
